export function autoInstallPluginSettingToBundle(setting, pluginsData) {
    return {
        id: setting.id,
        filters: setting.filters,
        rules: setting.content.map(plugin => mapPluginContentToRule(plugin, pluginsData))
    };
}
export function pluginRuleBundleToAutoInstallPluginSetting(bundle, tools) {
    var _a;
    return {
        id: (_a = bundle.id) !== null && _a !== void 0 ? _a : crypto.randomUUID(),
        filters: bundle.filters,
        tools,
        content: bundle.rules
            .filter((rule) => rule.type === 'single-plugin')
            .filter(rule => rule.action === 'auto-install' || rule.action === 'force-auto-install')
            .map(rule => mapRuleToPluginContent(rule))
    };
}
function mapPluginContentToRule(pluginContent, pluginsData) {
    const pluginModel = pluginsData.get(pluginContent.pluginId);
    return {
        type: 'single-plugin',
        action: pluginContent.forced ? 'force-auto-install' : 'auto-install',
        singlePluginTypeRule: mapPluginContentToRuleType(pluginContent, pluginModel)
    };
}
function mapRuleToPluginContent(rule) {
    switch (rule.singlePluginTypeRule.type) {
        case 'marketplace':
            return mapMarketplacePluginToPluginContent(rule.singlePluginTypeRule, rule.action);
        case 'internal-repo':
            return mapInternalRepoToPluginContent(rule.singlePluginTypeRule, rule.action);
        case 'bundled':
            return mapBundledPluginToPluginContent(rule.singlePluginTypeRule, rule.action);
        default:
            return assert_exhaustive(rule.singlePluginTypeRule);
    }
}
function mapPluginContentToRuleType(pluginContent, model) {
    switch (pluginContent.source) {
        case 'MARKETPLACE':
            return mapPluginContentToMarketplacePlugin(pluginContent, model);
        case 'TBE':
            return mapPluginContentToInternalRepoPlugin(pluginContent, model);
        default:
            return assert_exhaustive(pluginContent.source);
    }
}
function mapPluginContentToMarketplacePlugin(autoInstalledPluginContent, model) {
    return {
        type: 'marketplace',
        pluginDefinition: { id: autoInstalledPluginContent.pluginId, name: model === null || model === void 0 ? void 0 : model.label },
        version: autoInstalledPluginContent.version
            ? {
                type: 'custom',
                version: autoInstalledPluginContent.version
            }
            : { type: 'latest' }
    };
}
function mapPluginContentToInternalRepoPlugin(autoInstalledPluginContent, model) {
    if (autoInstalledPluginContent.type === 'channel') {
        return {
            type: 'internal-repo',
            pluginDefinition: { id: autoInstalledPluginContent.pluginId, name: model === null || model === void 0 ? void 0 : model.label },
            channel: autoInstalledPluginContent.channel
                ? {
                    id: autoInstalledPluginContent.channel.id,
                    name: autoInstalledPluginContent.channel.name
                }
                : undefined
        };
    }
    return {
        type: 'internal-repo',
        pluginDefinition: { id: autoInstalledPluginContent.pluginId, name: model === null || model === void 0 ? void 0 : model.label },
        version: autoInstalledPluginContent.version
            ? {
                type: 'specific',
                version: {
                    id: autoInstalledPluginContent.version,
                    name: autoInstalledPluginContent.version
                }
            }
            : { type: 'latest' }
    };
}
function mapInternalRepoToPluginContent(rule, action) {
    var _a;
    return {
        pluginId: rule.pluginDefinition.id,
        forced: action === 'force-auto-install',
        source: 'TBE',
        version: ((_a = rule.version) === null || _a === void 0 ? void 0 : _a.type) === 'specific' ? rule.version.version.name : undefined,
        channel: rule.channel ? { id: rule.channel.id, name: rule.channel.name } : undefined,
        type: rule.channel ? 'channel' : 'version'
    };
}
function mapMarketplacePluginToPluginContent(rule, action) {
    return {
        pluginId: rule.pluginDefinition.id,
        forced: action === 'force-auto-install',
        source: 'MARKETPLACE',
        version: rule.version.type === 'custom' ? rule.version.version : undefined,
        type: 'version',
        description: 'According to corporate rules new plugins were added to the IDE'
    };
}
function mapBundledPluginToPluginContent(rule, action) {
    return {
        pluginId: rule.pluginDefinition.id,
        forced: action === 'force-auto-install',
        source: 'MARKETPLACE',
        type: 'version',
        description: 'According to corporate rules new plugins were added to the IDE'
    };
}
